import { render, staticRenderFns } from "./AdminTotpSetup.vue?vue&type=template&id=2f9be00a&"
import script from "./AdminTotpSetup.vue?vue&type=script&lang=js&"
export * from "./AdminTotpSetup.vue?vue&type=script&lang=js&"
import style0 from "./AdminTotpSetup.vue?vue&type=style&index=0&id=2f9be00a&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports